// packages/ui/src/components/headerMenuItems.ts
import { Info, Heart, Settings, RefreshCw, RotateCcw, Power } from 'lucide-react';
import type { ContextMenuEntry } from '../context-menu';

export interface LogoMenuHandlers {
  onAbout: () => void;
  onAcknowledgements: () => void;
  onSettings: () => void;
  onCheckUpdates: () => void;
  onQuit: () => void;
  /** Relaunch the app. Shown whenever provided (callers gate on the platform's
   *  restartApp capability). Grouped with Quit. */
  onRestart?: () => void;
  /** Desktop builds expose Check for Updates + Quit; web hides them. */
  isDesktop: boolean;
}

/**
 * Build the logo dropdown menu entries (consumed via the context-menu infra).
 * Pure so the item set + desktop gating are unit-testable.
 */
export function buildLogoMenu(h: LogoMenuHandlers): ContextMenuEntry[] {
  const items: ContextMenuEntry[] = [
    { id: 'about', label: 'About Slate', icon: Info, onSelect: h.onAbout },
    { id: 'acknowledgements', label: 'Acknowledgements…', icon: Heart, onSelect: h.onAcknowledgements },
    { type: 'separator', id: 'sep1' },
    { id: 'settings', label: 'Settings…', icon: Settings, shortcut: '⌘,', onSelect: h.onSettings },
  ];
  if (h.isDesktop) {
    items.push({
      id: 'check-updates',
      label: 'Check for Updates…',
      icon: RefreshCw,
      onSelect: h.onCheckUpdates,
    });
  }
  // Restart + Quit form a bottom group below a shared separator. Restart shows
  // whenever a handler is provided (desktop relaunch / web reload); Quit is
  // desktop-only.
  if (h.onRestart || h.isDesktop) {
    items.push({ type: 'separator', id: 'sep2' });
  }
  if (h.onRestart) {
    items.push({ id: 'restart', label: 'Restart Slate', icon: RotateCcw, onSelect: h.onRestart });
  }
  if (h.isDesktop) {
    items.push({ id: 'quit', label: 'Quit Slate', icon: Power, shortcut: '⌘Q', onSelect: h.onQuit });
  }
  return items;
}
